const places = "collected-places";
const bestBikingRoads = "best-biking-roads";

export const ROUTES = Object.freeze({
  Login: "/login",
  Search: "/",
  Widgets: "/widgets",
  Tags: "/tags",

  // Route: {
  //   Build: "route",
  // },

  Routes: {
    Build: "/build-route",
    List: "/routes",
  },

  Places: {
    List: `${places}`,
    Overview: `${places}/:id`,
    Upload: `${places}/upload`,
    Availability: `${places}/availability`,
  },

  BestBikingRoads: {
    List: `${bestBikingRoads}`,
    Create: `${bestBikingRoads}/create`,
  },

  GraphhopperKeys: {
    Home: "/graphhopper-keys",
  },
});

export const NAVIGATION = [
  [
    {
      label: "Places",
      to: ROUTES.Places.List,
      secondary: "List of collected places",
    },
    {
      label: "Availability",
      to: ROUTES.Places.Availability,
      secondary: "Check availability of places",
    },
    {
      label: "Upload",
      to: ROUTES.Places.Upload,
      secondary: "Upload places from .csv",
    },
  ],
  [
    {
      label: "Widgets",
      to: ROUTES.Widgets,
      secondary: "Algorithms representation",
    },
  ],
  [
    {
      label: "Routes List",
      to: ROUTES.Routes.List,
      secondary: "See all built by users routes",
    },
    {
      label: "Route",
      to: ROUTES.Routes.Build,
      secondary: "Build Route",
    },
  ],
  [
    {
      label: "Best Biking Roads",
      to: ROUTES.BestBikingRoads.List,
      secondary: "Collect and list or roads",
    },
    {
      label: "Create Best Biking Road",
      to: ROUTES.BestBikingRoads.Create,
      secondary: "Create Best Biking Roads",
    },
  ],
  [
    {
      label: "Tags",
      to: ROUTES.Tags,
      secondary: "Manage places tags",
    },
  ],
  [
    {
      label: "Graphhopper Keys",
      to: ROUTES.GraphhopperKeys.Home,
      secondary: "Manage Keys",
    },
  ],
];
